import { gql } from '@apollo/client'

export const MUTATION_RETURN_DEVICE = gql`
  mutation mutationReturnDevice($input: ReturnDeviceInput!) {
    returnDevice(input: $input) {
      id
    }
  }
`
